import * as React from "react";
import GroupSettingsStore from "../../Courses/GroupSettings/store";
import { MobXProviderContext } from "mobx-react";
import { Box, makeStyles } from "@material-ui/core";
import { tl } from "../../../../utils";
import { BenefitField } from "../PlanChoise/benefitField";

import { IBenefit, IIdBenefit } from "../../Courses/GroupSettings/types";
import { themeVariables } from "..";

interface IProps {
  benefits: IBenefit[];
  courseBenefit: IIdBenefit;
  onBenefitChange?: (benefitValue: number) => void;
  getCurrency: (code: string) => string;
}

export const MUIShopBenefit = ({
  benefits,
  courseBenefit,
  onBenefitChange,
  getCurrency,
}: IProps) => {
  const bene = benefits?.find(
    (benefit) => benefit.id === courseBenefit?.benefitId
  );
  const getPriceCurrency = () => {
    return bene
      ? `${bene.price ? bene.price : 0} ${
          bene.currency ? getCurrency(bene.currency) : ""
        }`
      : "";
  };

  const classes = makeStyles({
    price: {
      paddingLeft: themeVariables.spacing * 8,
      [themeVariables.breakpoints.down("sm")]: {
        paddingLeft: 0,
        marginLeft: "auto",
      },
    },
  })({});
  return bene ? (
    <BenefitField
      list={benefits}
      value={bene.id}
      changeValue={onBenefitChange}
      label={tl("Формат обучения:")}
      isDescription
    >
      <Box className={classes.price}>{getPriceCurrency()}</Box>
    </BenefitField>
  ) : null;
};
